import {
  hoursWatchedText,
  peakCCVText,
  avgCCVText,
  airtimeText,
} from '@/pages/opinion/components/BubbleCommon';
import { arrayToObj, arrayToSimpleObj } from '@/pages/opinion/utils';
import { avgValueFormat, reviewsFormat } from '@/pages/opinion/utils/value';
export const metricsOptions = [
  {
    text: 'Hours Watched(hours)',
    title: 'Hours Watched',
    subTitle: '(hours)',
    value: 'hoursWatched',
  },
  { text: 'Peak CCV', title: 'Peak CCV', value: 'peakCCV' },
  { text: 'Avg CCV', title: 'Avg CCV', value: 'avgCCV' },
  {
    text: 'Airtime(hours)',
    title: 'Airtime',
    subTitle: '(hours)',
    value: 'airtime',
  },
];

const chzzkGameList = [
  'uef4312b08dde07820374dd57086ea2fb',
  'uf0a4c651423effde0425337ca0a2fd51',
  'ub3cc395e65978801654713d3dc25a4db',
  'u72c49cf5c8b11337fb27bdf8c21976e7',
  'u2b279ea0568e35220d89c38b4497d6f8',
  'u9495a569f462cf137e7289680423c952',
  'u10000000088',
  'udcba528a7c314262d50dfdcb71591be9',
  'ub659a6590ec43ee8f2dddfe9ce70c654',
  'u799fa40a5a7b726d0c6f14d08f5b7bfc',
];
export const defaultChannelList = [
  'twitch',
  'ytg',
  'facebook',
  'chzzk',
  'afreeca',
];
/**
 * TODO: 其他系统使用
 * 修改youtube 为 ytg
 * @param channels
 * @returns
 */
export const changeChannel = (channels: Array<string>) => {
  return channels.map((item) => (item === 'youtube' ? 'ytg' : item));
};

/**
 * TODO: 其他系统使用
 * 获取默认渠道
 * @returns
 */
export const getDefaultChannelList = () => {
  return defaultChannelList;
};

export const metricsMap = arrayToSimpleObj(metricsOptions);
export const metricsObjMap = arrayToObj(metricsOptions, 'value');

export const channelNameMap: any = {
  ytg: 'Youtube',
  twitch: 'Twitch',
  facebook: 'Facebook',
  chzzk: 'Chzzk',
  afreeca: 'Sooplive',
};

export const channelColorMap: any = {
  twitch: '#9147FF',
  ytg: '#DD2C00',
  facebook: '#1877F2',
  chzzk: '#00E693',
  afreeca: '#D5E342',
};

export const sortChannelMap: any = {
  twitch: 1,
  ytg: 2,
  facebook: 3,
  chzzk: 4,
  sooplive: 5,
};

export const tipsMap: any = {
  hoursWatched: hoursWatchedText,
  peakCCV: peakCCVText,
  avgCCV: avgCCVText,
  airtime: airtimeText,
};

export const titleMap: any = {
  hoursWatched: 'Sum Hours Watched',
  peakCCV: 'Max CCV',
  avgCCV: 'Avg CCV',
  airtime: 'Sum Airtime',
};

export const countMap: any = {
  hoursWatched: 'total',
  peakCCV: 'peakCCvMax',
  avgCCV: 'avg',
  airtime: 'total',
};

export const timelineTypeOptions = [
  { text: 'Mentions', value: 'mentions' },
  { text: 'Negative', value: 'negative' },
  { text: 'Non Negative%', value: 'non-negative' },
  { text: 'Sentiment', value: 'sentiment' },
];

export const timeLineTypeMap = arrayToSimpleObj(timelineTypeOptions);

export const formatValueMap: any = {
  kolNumber: (value: number) => reviewsFormat(value),
  publications: (value: number) => reviewsFormat(value),
  engagements: (value: number) => reviewsFormat(value),
  followers: (value: number) => reviewsFormat(value),
  peakCCV: (value: number) => reviewsFormat(value),
  avgCCV: (value: number) => avgValueFormat(value),
  hoursWatched: (value: number) => avgValueFormat(value),
  airtime: (value: number) => avgValueFormat(value),
};

// 表格数据key，与后端接口对应
export const tableDataKeys = [
  'mentions',
  'engagements',
  'followers',
  'likes',
  'posts',
  'shares',
  'views',
  'view_per_post',
];
export const streamingTableDataKeys = [
  'followers',
  'airtime',
  'avg_ccv',
  'hours_watched',
  'peak_ccv',
];
